var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import { NodeElement } from './base/node-element';
import { DiagramConsts } from '../diagram-consts';
import { SectorReshapingTool } from '../tools/SectorReshapingTool';
var SectorElement = /** @class */ (function (_super) {
    __extends(SectorElement, _super);
    function SectorElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectorElement.prototype.compile = function (model, data, _svg) {
        model['version'] = 4;
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
    };
    SectorElement.prototype.makeSector = function (data) {
        if (data['sweep'] < 1) {
            data.sweep = 1;
        }
        var radius = SectorReshapingTool.prototype.getRadius(data);
        var angle = SectorReshapingTool.prototype.getAngle(data);
        var sweep = SectorReshapingTool.prototype.getSweep(data);
        var start = new go.Point(radius, 0).rotate(angle);
        // this is much more efficient than calling go.GraphObject.make:
        var geo = new go.Geometry()
            .add(new go.PathFigure(radius + start.x, radius + start.y) // start point
            .add(new go.PathSegment(go.PathSegment.Arc, angle, sweep, // angles
        radius, radius, // center
        radius, radius)) // radius
            .add(new go.PathSegment(go.PathSegment.Line, radius, radius).close()))
            .add(new go.PathFigure(0, 0)) // make sure the Geometry always includes the whole circle
            .add(new go.PathFigure(2 * radius, 2 * radius)); // even if only a small sector is "lit"
        return geo;
    };
    SectorElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Shape, 'Piepiece', { margin: 10, fill: 'transparent', width: 40, height: 40, stroke: '#999999' }), $(go.TextBlock, { alignment: go.Spot.Center, text: this.l(this.getCategoryKey()), editable: false }));
    };
    SectorElement.prototype.getDiagramTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Spot', {
            locationSpot: go.Spot.Center, locationObjectName: 'LAMP',
            selectionObjectName: 'LAMP', selectionAdorned: false,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), new go.Binding('layerName', 'isSelected', function (s) {
            return s ? 'Foreground' : '';
        }).ofObject(), $(go.Panel, 'Spot', { name: 'LAMP' }, $(go.Shape, // arc
        { fill: '#ffffff', stroke: '#333', strokeWidth: 1 }, new go.Binding('geometry', '', this.makeSector), new go.Binding('fill'), new go.Binding('stroke'), new go.Binding('strokeWidth'))));
    };
    SectorElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.sectorKey;
    };
    return SectorElement;
}(NodeElement));
export { SectorElement };
